import React from 'react';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

function SearchBar({
    filterPrice, onFilterPriceChange,
    type, onTypeChange,
    minSize, onMinSizeChange,
    district, onDistrictChange,
    minYear, onMinYearChange,
}) {
    const types = ['', 'Trung cấp', 'Cao cấp', 'Bình dân'];
    const districts = ['', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', 'Tân Phú', 'Bình Chánh', 'Nhà Bè', 'Tân Bình'];

    return (
        <div className="search-bar-container">
            <TextField
                label="Max Price"
                type="number"
                value={filterPrice}
                onChange={(e) => onFilterPriceChange(e.target.value)}
                fullWidth
            />

            <TextField
                label="Apartment Type"
                select
                value={type}
                onChange={(e) => onTypeChange(e.target.value)}
                fullWidth
            >
                {types.map((option) => (
                    <MenuItem key={option} value={option}>{option || "Any"}</MenuItem>
                ))}
            </TextField>

            <TextField
                label="Min Area (m²)"
                type="number"
                value={minSize}
                onChange={(e) => onMinSizeChange(e.target.value)}
                fullWidth
            />

            <TextField
                label="District"
                select
                value={district}
                onChange={(e) => onDistrictChange(e.target.value)}
                fullWidth
            >
                {districts.map((option) => (
                    <MenuItem key={option} value={option}>{option || "Any"}</MenuItem>
                ))}
            </TextField>

            <TextField
                label="Min Handover Year"
                type="number"
                value={minYear}
                onChange={(e) => onMinYearChange(e.target.value)}
                fullWidth
            />
        </div>
    );
}

export default SearchBar;
